import { Edit as EditRecipient } from './Edit';

export default EditRecipient;
